module.exports = __webpack_public_path__ + "img/Camera5.3390ccb7.png";